<template>
  <div class="mt-12 bg-yellow-300 p-8 rounded inline-block text-center">
    <div class="text-2xl font-thin">
      🎉 &nbsp; Enjoying {{ getAppName }}?
    </div>

    <div class="mt-4 text-sm">
      Share {{ getAppName }} with those you know!
    </div>

    <div class="mt-4">
      <a :href="'https://www.linkedin.com/shareArticle?mini=true&url=https://www.brokerpad.com.au&title=' + shareableTitle + '&summary=' + shareableDescription + '&source=brokerpad.com.au'" rel="noopener" target="_blank">
        <img src="https://cdn2.iconfinder.com/data/icons/social-icon-3/512/social_style_3_in-512.png" width="50" class="inline" />
      </a>
      
      &nbsp;&nbsp;&nbsp;
      
      <a href="https://www.facebook.com/dialog/share?app_id=645057395962262&display=popup&href=https://www.brokerpad.com.au" rel="noopener" target="_blank">
        <img src="https://cdn2.iconfinder.com/data/icons/social-icon-3/512/social_style_3_facebook-512.png" width="50" class="inline" />
      </a>
      
      &nbsp;&nbsp;&nbsp;
      
      <a :href="'https://twitter.com/intent/tweet?text=Check out Brokerpad! - ' + shareableTitle + '&url=https://www.brokerpad.com.au'" rel="noopener" target="_blank">
        <img src="https://cdn2.iconfinder.com/data/icons/social-icon-3/512/social_style_3_twiter-512.png" width="50" class="inline" />
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    computed : {
      shareableTitle() {
        return encodeURIComponent("Brokerpad is a secure online fact find and document collection platform for mortgage brokers")
      },

      shareableDescription() {
        return encodeURIComponent("Brokerpad is a secure online fact find and document collection platform for mortgage brokers that makes it easy to collect information from clients. It can automate your loan process from Client to Broker to Bank. Here are just some of the features that will help you to be more efficient.")
      }
    }
  }
</script>